import script from "./RefundManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./RefundManagement.vue?vue&type=script&setup=true&lang=js"

import "./RefundManagement.vue?vue&type=style&index=0&id=f46b2172&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f46b2172"]])

export default __exports__